// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import FileAttachmentList from './file-attachment-list-cloud';
import FileUpload from '../file-upload-cloud/file-upload-cloud';
import {FormattedMessage} from 'react-intl';

const doNothing = () => ({});

const FileAttachmentPanel = props =>
    <section className='file-upload-panel'>
        <header>
            <FormattedMessage id='ATTACHMENTS'/>
        </header>
        <FileAttachmentList
            files={props.files}
            onFileDelete={props.onFileDelete}
        />
        {props.isUploadAllowed &&
            <FileUpload
                displayMessage={props.displayMessage}
                djsConfig={props.djsConfig}
                handleFileDelete={doNothing}
                handleFileUploadSuccess={props.onFileUploadSuccess}
                isRequired={props.isRequired}
                serviceConfig={props.serviceConfig}
            />
        }
    </section>;

FileAttachmentPanel.displayName = 'FileAttachmentPanel';

FileAttachmentPanel.propTypes = {
    displayMessage: PropTypes.string,
    djsConfig: PropTypes.object,
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    isRequired: PropTypes.bool,
    isUploadAllowed: PropTypes.bool.isRequired,
    onFileDelete: PropTypes.func.isRequired,
    onFileUploadSuccess: PropTypes.func.isRequired,
    serviceConfig: PropTypes.shape({
        className: PropTypes.string.isRequired,
        classType: PropTypes.string.isRequired,
        objectKey: PropTypes.string.isRequired
    })
};
FileAttachmentPanel.defaultProps = {
    djsConfig: {},
    isRequired: false,
    isUploadAllowed: true
};

export default FileAttachmentPanel;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-form/file-attachment-panel-cloud/index.js